import template from './unauthenticated-container.component.html';

const unauthenticatedContainer = {
  template,
};

export default unauthenticatedContainer;
